import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import VideosPage from '@/pages/videos/page';
import VideoDetailPage from '@/pages/videos/DetailPage';
import CommunityPage from '@/pages/community/page';
import StudentPage from '@/pages/community/StudentPage';
import TeacherPage from '@/pages/community/TeacherPage';
import ParentPage from '@/pages/community/ParentPage';
import ShopPage from '@/pages/shop/page';
import ShopDetailPage from '@/pages/shop/DetailPage';
import AboutPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';
import AuthPage from '@/pages/auth/page';
import ProfilePage from '@/pages/profile/page';
import CartPage from '@/pages/cart/page';
import DonatePage from '@/pages/donate/page';
import TeacherDashboardPage from '@/pages/teacher/dashboard/page';
import SellerDashboardPage from '@/pages/seller/dashboard/page';
import OrdersPage from '@/pages/orders/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/login', element: <AuthPage /> },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/videos', element: <VideosPage /> },
  { path: '/videos/:id', element: <VideoDetailPage /> },
  { path: '/community', element: <CommunityPage /> },
  { path: '/community/student', element: <StudentPage /> },
  { path: '/community/teacher', element: <TeacherPage /> },
  { path: '/community/parent', element: <ParentPage /> },
  { path: '/shop', element: <ShopPage /> },
  { path: '/shop/:id', element: <ShopDetailPage /> },
  { path: '/cart', element: <CartPage /> },
  { path: '/donate', element: <DonatePage /> },
  { path: '/teacher/dashboard', element: <TeacherDashboardPage /> },
  { path: '/seller/dashboard', element: <SellerDashboardPage /> },
  { path: '/orders', element: <OrdersPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
